import React from 'react';
import Input from 'blocks/Input';
import _ from 'lodash';
import NewUserHttpService from 'services/NewUserHttpService';
import HttpClient from 'services/HttpClient';
import { withRouter, Link } from 'react-router-dom'

const ERROR_TEXT = ['The email address and / or password you provided are incorrect. Please try again'];
import {inject, observer } from 'mobx-react'
import { observe } from 'mobx';
import {IACP_LOGO} from 'constants/sponsor_logos';

@withRouter
@inject('user')
@inject('alert')
@inject("SponsorStore")
@observer
export default class SignIn extends React.Component {

  state = {
    email: '',
    password: '',
    errorText: '',
    iacpLogin: false,
    iacpError: false
  };

  toggleLoginType = (e) => {
    e.preventDefault();
    console.log('iacp switched')
    this.setState({
      iacpLogin: true,
      iacpError: false
    });
    var self = this;
    window.addEventListener('message', function (e) {
      // console.log('msg: ', e.data);
      const message = e.data;
      if (typeof message === 'string' && message.includes('http://therapyacademy.ie/auth_iacp?token=')) {
        // console.log('iacp message: ', e.data, message.slice(24));
        const auth_iacp_route = message.slice(24);
        self.props.history.push(auth_iacp_route);
      } else if (typeof message === 'string' && message === 'Email or password incorrect') {
        self.setState({
          iacpLogin: false,
          iacpError: true
        });
      }
    }, false)
  }
  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit(event);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    new NewUserHttpService().signIn(this.state)
      .then( body => this.handleSuccess(body.data))
      .catch( data => {
        this.props.alert.error(ERROR_TEXT[0]);
        this.setState({errorText: [''], password: ''})
      })
  };

  handleChange = data => {
    let newState = _.assign({}, this.state, data);
    this.setState(newState)
  };

  handleSuccess = data => {
    const workshop_id = localStorage.getItem('@workshop_id');
    this.props.user.loginUser(data.user);
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user) );
    const {governing_body} = data.user;
    new HttpClient().post('/api/v1/workshops/romove_fixed_status')
    if(workshop_id) {
      localStorage.removeItem('@workshop_id');
      this.props.history.push(`/details/online/${workshop_id}`);
    }
    // else if (governing_body == 'iacp') {
    //   this.props.history.push('/iacp')
    // } else if (governing_body == 'aci') {
    //   this.props.history.push('/aci')
    // }
    else
    if (this.props.SponsorStore.fromSponsor) {
      const sponsorRoute = this.props.SponsorStore.fromSponsorId;
      this.props.history.push(`/${sponsorRoute}`);
    } if (data.user.proffession_description === 'General Public') {
      this.props.history.push('/public_webinars');
    } else {
      this.props.history.push('/webinars');
    }
  };

  render(){
    const sponsorLogo = (
      // for future logic with diff sponsorId's
      <div className='row'>
        <div className="col">
          <div className='spons-logo-newuser'>
            <img src={IACP_LOGO} alt="spons"/>
          </div>
        </div>
      </div>
    )

    return (
      <div className="row justify-content-center align-items-center sign-up-form-holder">
        <div className="col-12 col-md-10">
          <form onKeyDown={this.onKeyDown} onSubmit={this.handleSubmit}>
            {this.props.SponsorStore.fromSponsor ? sponsorLogo : null }
            <div className="row">
              <div className="col">
                <h1 className="sign-up-title">IACP MEMBERS LOG IN</h1>
              </div>
            </div>
            {!this.state.iacpLogin && (
              <div className="row">
                <div className="col-12">
                  <p style={{fontSize: 15, marginTop: 40, marginBottom: 5 }}>Log in using your IACP username and password</p>
                  <p style={{fontSize: 15, marginBottom: 5, color: '#08c' }}>To reset your IACP password do so via <a href='www.iacp.ie' target='_blank'>www.iacp.ie</a></p>
                </div>
                <div className="col-12" style={{paddingTop: 20}}>
                  <button onClick={this.toggleLoginType} className='btn blue empty bordered iacp-btn'>
                    <span>Log In Via  <img src={IACP_LOGO} alt="IACP" style={{height: 22}} /></span>
                    {this.state.iacpError && <p style={{color: 'red', marginTop: 5, marginBottom: 0}}>email or password incorrect</p>}
                  </button>
                </div>
              </div>
            )}
            <div style={{height: 1, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.4)', marginTop: '20px'}} />
            {this.state.iacpLogin && (
              <div className='row'>
                <div className="col-12">
                  <p style={{fontSize: 15, marginTop: 40, marginBottom: 5 }}>Log in using your IACP username and password</p>
                </div>
                <div className="col-12">
                    <div className="iacp-iframe-container" style={{marginTop: 10, width: 352, height: 230, border: '1px solid'}}>
                      <iframe
                        id="iacp-iframe"
                        title="IACP User Authorization"
                        width="100%"
                        height="100%"
                        src="https://iacp.ie/page/loginmember/iframe" frameBorder="0"
                      >
                      </iframe>
                    </div>
                </div>
              </div>
            )}
            {/* <div style={{textAlign: 'center', marginTop: 20, fontWeight: 'bold'}}>
              <p>OR</p>
            </div> */}

            <div className="row" style={{marginTop: 20}}>
              <div className="col">
                <h1 className="sign-up-title">NON IACP <span style={{color: '#08c'}}>ACCOUNTS</span> LOG IN</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <p style={{fontSize: 15, marginTop: 40, marginBottom: 5 }}>Log in using your Therapy Academy email and password</p>
              </div>
              <div className="col-12">
                <Input name="email"
                      type="email"
                      value={this.state.email}
                      handleChange={this.handleChange}
                      placeholder="Email Address"
                        error={this.state.errorText}/>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Input name="password"
                          type="password"
                          value={this.state.password}
                          handleChange={this.handleChange}
                          placeholder="Password"
                          error={this.state.errorText}/>
                </div>
              </div>
              <div className="btn-holder">
                <button type="submit" className="btn blue empty bordered">login</button>
              </div>
              <div className="forgot-holder">
                <Link to="/newuser/forgotpassword" className="forgot">Forgot your password?<br /><span style={{color: '#08c'}}>(non iacp accounts only)</span></Link>
              </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/new_user/SignIn.jsx